import type { FetchAgreementsReportResult } from '../../agreements/report/fetch-agreements-report';
import type { DwtDefraSubmissionsTaskPaneFilter } from '../models/dwt-defra-submissions.model';
import { buildDwtDefraSubmissionsPayloadFromFilter } from '../utils/dwt-defra-submissions-filter-payload.builder';
import type { DwtDefraSubmissionsReportFetchDeps } from './dwt-defra-submissions-fetch.deps';
import { defaultDwtDefraSubmissionsReportFetchDeps } from './dwt-defra-submissions-fetch.deps';

/**
 * DEFRA submissions feature: Get-RegulatoryReports only (no Excel). Task pane formats records and writes.
 */
export async function fetchDwtDefraSubmissionsReport(
    accessToken: string,
    filter: DwtDefraSubmissionsTaskPaneFilter,
    deps: DwtDefraSubmissionsReportFetchDeps = defaultDwtDefraSubmissionsReportFetchDeps
): Promise<FetchAgreementsReportResult> {
    const payload = buildDwtDefraSubmissionsPayloadFromFilter(filter);
    const result = await deps.fetchGetDwtDefraSubmissions(accessToken, payload);

    if (result.kind === 'failure') {
        const source = result.source ?? 'http';
        return {
            kind: 'failure',
            message: result.message,
            source,
            ...(result.invalidElementIds !== undefined
                ? { invalidElementIds: result.invalidElementIds }
                : {}),
            ...(result.httpStatus !== undefined ? { httpStatus: result.httpStatus } : {}),
            ...(result.body !== undefined ? { body: result.body } : {}),
            debugErrorTitle: source === 'validation' ? 'Invalid filters' : 'Report fetch failed',
        };
    }

    const { body, records, totalCount, recordCount, httpStatus } = result;
    return {
        kind: 'success',
        records,
        recordCount,
        totalCount,
        body,
        httpStatus,
    };
}
